export type DesignType = string;

export type PosterStatus = "unplaced" | "placed" | "retired";

export interface LocationTags {
  neighborhood?: string;
  venue?: string;
  venueType?: string;
  visibilityRating?: number;
  facingDirection?: string;
}

export interface Poster {
  posterId: string;
  accountId: string;
  batchId: string;
  designType: DesignType;
  qrUrl: string;
  generatedAt: string;
  status: PosterStatus;
  isPlaced: boolean;
  placementLat?: number;
  placementLng?: number;
  placementAccuracy?: number;
  placementTimestamp?: string;
  placedBy?: string;
  tags?: LocationTags;
  notes?: string;
  photoUrl?: string;
  scanCount: number;
  lastScanAt?: string;
}

export interface ScanEvent {
  id: string;
  accountId: string;
  posterId: string;
  designType?: DesignType;
  scannedAt: string;
  userAgent?: string;
  referrer?: string;
  ipHash?: string;
  redirectUrl: string;
  ignoredForAnalytics?: boolean;
  resetAt?: string;
  resetBy?: string;
}

export interface PlacementPayload {
  posterId: string;
  lat: number;
  lng: number;
  accuracy?: number;
  notes?: string;
  tags?: LocationTags;
  photoUrl?: string;
}

export interface PosterUpdatePayload {
  designType?: string;
  batchId?: string;
  status?: PosterStatus;
  notes?: string;
  photoUrl?: string;
  placementLat?: number | null;
  placementLng?: number | null;
  placementAccuracy?: number | null;
  placementTimestamp?: string | null;
  tags?: LocationTags;
}

export interface DashboardStats {
  totalPosters: number;
  totalPlaced: number;
  totalScans: number;
  averageScansPerPoster: number;
  topDesign?: DesignType;
}

export const DEFAULT_DESIGN_PREFIX: Record<string, string> = {
  "Modern Minimal": "MOD",
  "Bold Impact": "BOLD",
  "Eco Friendly": "ECO",
  "Premium Luxe": "LUX"
};

export const DEFAULT_DESIGN_COLORS: Record<string, string> = {
  "Modern Minimal": "#2563eb",
  "Bold Impact": "#dc2626",
  "Eco Friendly": "#16a34a",
  "Premium Luxe": "#9333ea"
};

const FALLBACK_COLORS = ["#2563eb", "#dc2626", "#16a34a", "#9333ea", "#0f766e", "#c2410c", "#4f46e5", "#be123c"];

export function colorForDesign(designType: string) {
  if (DEFAULT_DESIGN_COLORS[designType]) return DEFAULT_DESIGN_COLORS[designType];
  const hash = Array.from(designType).reduce((sum, char) => sum + char.charCodeAt(0), 0);
  return FALLBACK_COLORS[hash % FALLBACK_COLORS.length];
}
